class FlexColors {
    static primary = '#2257BE'
}

export default FlexColors
